import { useRef, useState } from "react";
import { BACKEND } from "@/lib/api";

const URL_BASE = `${BACKEND}/api`;

const readEvents = async (res, onText) => {
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const msg = JSON.parse(ev.replace(/^data: /, ""));
      if (msg.error) throw new Error(msg.error);
      if (msg.text) onText(msg.text);
      if (msg.final !== undefined) onText(msg.final, true);
    }
  }
};

const failure = async (res) => {
  const detail = await res.json().then((d) => d.detail).catch(() => null);
  return new Error(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
};

// Streams a Server-Sent-Events POST, calling onText with the text so far (a "final" event replaces it); returns the full text.
export const useStream = () => {
  const [busy, setBusy] = useState(false);
  const abortRef = useRef(null);

  const run = async (path, body, onText) => {
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setBusy(true);
    let text = "";
    try {
      const res = await fetch(`${URL_BASE}${path}`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), signal: ctrl.signal,
      });
      if (!res.ok) throw await failure(res);
      await readEvents(res, (t, final) => { text = final ? t : text + t; onText(text); });
      return text;
    } catch (e) {
      if (e.name === "AbortError") return text;
      throw e;
    } finally {
      setBusy(false);
    }
  };

  return { busy, run, stop: () => abortRef.current?.abort() };
};
